
<template>
<div>
  <chc-modal ref="paymentDetailsModal" title="Payment Details">
    <div slot="body">
      <payment-details :towingCompanyId="towingid"
                    :paymentId="paymentId"
                        v-on:close="paymentDetailsHide">
      </payment-details>
    </div>
  </chc-modal>
  <div class="proceeds-container tabbed-content">
    <datatable
      :source="proceeds"
      :filterable="false"
      :isLoading="isLoading">
      <datatable-column
        v-for="(column, index) in columns"
        :id="column.id"
        :label="column.label"
        :key="index">
      </datatable-column>

      <template slot="searchLeft">
      </template>

      <template slot="source_template" slot-scope="data">
        <tr>
          <td>{{ data.row.date }}</td>
          <td>{{ data.row.check_number }}</td>
          <td>{{ data.row.vehicle_count }}</td>
          <td>{{ data.row.amount_paid }}</td>
          <td><a @click="viewDetails(data.row.id)">View Details</a></td>
        </tr>
      </template>

      <template slot="tfoot" slot-scope="data">
        <tr>
          <td>TOTAL</td>
          <td></td>
          <td>{{ total_paid }}</td>
          <td>{{ total }}</td>
          <td></td>
        </tr>
      </template>
    </datatable>
  </div>
</div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import store from '@/store'
import PaymentDetails from '@/components/Payables/PaymentDetails'

export default {
  name: 'TowingProceeds',
  props: ['towingid'],
  mounted () {
    Promise.all([
      store.functions.towingCompanies.getProceeds(this.towingid, (response) => {
        this.proceeds = response.data.table_data
        this.total_paid = response.data.total_paid
        this.total = response.data.total
      })
    ]).then(response => {
      // pass
    }).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    return {
      columns: [
        { id: 'date', label: 'Date Paid' },
        { id: 'check_number', label: 'Check #' },
        { id: 'vehicle_count', label: 'Vehicle Count' },
        { id: 'amount_paid', label: 'Amount Paid' },
        { id: 'view', label: 'View Details' }
      ],
      isLoading: true,
      proceeds: [],
      total_paid: 0,
      total: 0,

      paymentId: null,
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    PaymentDetails
  },
  methods: {
    refresh () {
    },
    viewDetails (id) {
      this.paymentId = id
      this.$refs.paymentDetailsModal.show()
    },
    paymentDetailsHide () {
      this.$refs.paymentDetailsModal.hide()
    }
  }
}
</script>

<style scoped>
.proceeds-container {
  padding-top: 2em;
}

</style>



// WEBPACK FOOTER //
// src/components/TowingCompany/TowingProceeds.vue